<div class="side-panel-tags-container">

    @if(tags?.length > 0) {

        <p class="tags-title">Le tue scelte:</p>

        <div class="tags-container">

            @for(tag of tags; track tag.id) {

                <div class="tag" (click)="tagClicked(tag)" [matTooltip]="tag.text">
                    <div class="tag-text"><p>{{tag.text}}</p></div>
                    <div class="tag-bar-container">
                        <div class="tag-bar" [ngStyle]="{'width': getTagWidth(tag)}"></div>
                        @if(tag.nProducts != null) { <div class="tag-n-products">{{tag.nProducts | number}}</div> }
                    </div>
                </div>

            }

        </div>
    }

</div>